import { restClient } from '../../core/network/restClient';

// Upload chung của BE (FileService), không gắn với khiếu nại — màn nào cần đính kèm file cũng dùng được.
const PUBLIC_UPLOAD_PATH = '/api/v1/public/upload-files';

// gRPC nhận tối đa 20MB/request; 10MB file gốc ≈ 13.5MB base64 là còn dư.
// Video 30MB (≈ 40MB base64) vẫn đi riêng 1 lô và cần BE nâng giới hạn này mới qua được.
const MAX_BATCH_BYTES = 10 * 1024 * 1024;
// Timeout chung 15s không đủ cho video 30MB trên mạng chậm.
const UPLOAD_TIMEOUT_MS = 120000;

// readAsDataURL trả "data:<mime>;base64,<nội dung>"; BE chỉ nhận phần sau dấu phẩy.
const readAsBase64 = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(String(reader.result).split(',')[1] ?? '');
    reader.onerror = () => reject(reader.error);
    reader.readAsDataURL(file);
  });

// Gộp file liền nhau cho tới khi chạm trần. File to hơn trần vẫn đi riêng một lô.
const splitIntoBatches = (files) =>
  files.reduce((batches, file) => {
    const last = batches[batches.length - 1];
    if (last && last.size + file.size <= MAX_BATCH_BYTES) {
      last.files.push(file);
      last.size += file.size;
    } else {
      batches.push({ files: [file], size: file.size });
    }
    return batches;
  }, []);

// Trả mảng URL cùng thứ tự với files. Gửi từng lô nối tiếp để giữ thứ tự và không dồn vào rate-limit 20/phút.
export const uploadPublicFiles = async (files = []) => {
  const urls = [];
  for (const batch of splitIntoBatches(files)) {
    const body = {
      files: await Promise.all(
        batch.files.map(async (file) => ({ fileName: file.name, content: await readAsBase64(file) }))
      ),
    };
    const { data } = await restClient.post(PUBLIC_UPLOAD_PATH, body, { timeout: UPLOAD_TIMEOUT_MS });
    urls.push(...(data?.files || []).map((file) => file?.url));
  }
  return urls;
};
